export function SET_JOBS(state, jobs) {
  state.jobs = jobs;
}

export function SET_AVAILABLE(state, available) {
  state.available = available;
}